import { Component } from '@angular/core';
import { AEmptyBasePage } from '../empty.base.page';

@Component({
    selector: 'app-empty-about',
    templateUrl: '../empty.base.page.html',
    styleUrls: ['../empty.base.page.css']
})
export class EmptyAboutPage extends AEmptyBasePage {
    constructor() {
        super();
        this.pageTitleKey = '@@AboutPageTitle';
        this.pageDescriptionKey = '@@AboutPageDescription';
        this.settingItems = [
            {
                icon: 'pi pi-file-o',
                titleKey: '@@Logs',
                descriptionKey: '@@LogsDesc',
                link: '/settings/about/logs'
            },
            {
                icon: 'pi pi-list',
                titleKey: '@@Jobs',
                descriptionKey: '@@JobsDesc',
                link: '/settings/about/jobs/job-logs'
            },
            {
                icon: 'pi pi-th-large',
                titleKey: '@@ChangeLogOverview',
                descriptionKey: '@@OverviewDesc',
                link: '/settings/about/overview/changelog-overview'
            }
        ];
    }
}
